import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

export const OrganisationsAdvancedTable = () => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const {items} = useFilterContext()
	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	const rowModalLink = row => `/firms/organisations/${row.original.id}/edit`

	return <AdvancedTable data={tableData} rowModalLink={rowModalLink} />
}
